import * as React from 'react';
import { cn } from '../lib/cn';

/**
 * Skeleton — loading placeholder.
 * Uses a soft shimmer using the `animate-shimmer` keyframes from the preset.
 */

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded-md bg-sand-100 animate-pulse-soft',
        'bg-gradient-to-r from-sand-100 via-sand-200 to-sand-100 bg-[length:1000px_100%] animate-shimmer',
        className,
      )}
      {...props}
    />
  );
}
